import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Table
} from "reactstrap";
import { Badges } from "AbstractElements";
import { Link } from "react-router-dom";
import Moment from "moment";
import "moment/locale/id";

const topicOptions = ["global", "is_not_verified", "dev_global", "dev_is_not_verified"];

const HistoryNotif = ({ historyData }) => {
  return (
    <Container fluid={true}>
      <Row>
        <Col sm="12 order-2">
          <Card>
            <CardBody>
              {/* Scroll container: horizontal (kiri/kanan) + vertical (bawah) */}
              <div style={{ overflow: "auto", maxHeight: "85vh" }}>
                <Table className="table-bordered table-striped table-hover" style={{ minWidth: 1200, tableLayout: "auto", wordBreak: "break-word", whiteSpace: "normal" }}>
                  <thead style={{ position: "sticky", top: 0, zIndex: 10 }}>
                    <tr>
                      <th className="bg-primary text-light" style={{ position: "sticky", top: 0 }}>{'ID'}</th>
                      <th className="bg-primary text-light" style={{ width: "10px", position: "sticky", top: 0 }}>{'Topik'}</th>
                      <th className="bg-primary text-light" style={{ width: "180px", position: "sticky", top: 0 }}>{'Analytics Label'}</th>
                      <th className="bg-primary text-light" style={{ width: "220px", position: "sticky", top: 0 }}>{'Judul'}</th>
                      <th className="bg-primary text-light" style={{ width: "220px", position: "sticky", top: 0 }}>{'Deskripsi'}</th>
                      <th className="bg-primary text-light" style={{ width: "15%", position: "sticky", top: 0 }}>{'Diarahkan ke'}</th>
                      <th className="bg-primary text-light" style={{ width: "100px", position: "sticky", top: 0 }}>{'Gambar'}</th>
                      <th className="bg-primary text-light" style={{ width: "120px", position: "sticky", top: 0 }}>{'Dibuat pada'}</th>
                      <th className="bg-primary text-light" style={{ width: "120px", position: "sticky", top: 0 }}>{'Dikirim pada'}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      historyData && historyData.map((item, index) => {
                        const scheduledAt = item?.scheduled_at ? Moment(item.scheduled_at) : null;
                        const createdAt = item?.created_at ? Moment(item.created_at) : null;
                        const isSentBySchedule = scheduledAt && createdAt && scheduledAt.isSame(createdAt, 'minute');

                        // Cek apakah notifikasi sudah dikirim
                        // Jika ada scheduled_at, gunakan itu. Jika tidak, gunakan created_at
                        const now = Moment();
                        const isAlreadySent = scheduledAt
                          ? scheduledAt.isSameOrBefore(now)
                          : createdAt && createdAt.isSameOrBefore(now);

                        return (
                          <tr
                            key={`notif-${item.id}-${index}`}
                            className="table-light"
                          >
                            <td width={45} style={{ verticalAlign: 'middle' }}>
                              {item.id}

                              <Badges
                                attrBadge={{
                                  color: isAlreadySent ? 'success' : 'warning'
                                }}
                                className="mt-1"
                                style={{ fontSize: '0.7rem' }}
                              >
                                {isAlreadySent ? '✓ Sudah Dikirim' : '⏳ Belum Dikirim'}
                              </Badges>
                            </td>

                            <td style={{ verticalAlign: 'middle', wordBreak: "break-word", whiteSpace: "normal" }}>
                              {item.topics.map((topic, idx) => {
                                let topicId = topic.split('_');
                                let topicIdNum = parseInt(topicId[topicId.length - 1], 10);
                                const isMembershipTopic = !topicOptions.includes(topic);
                                const badge = (
                                  <Badges
                                    key={`topic-badge-${item.id}-${idx}`}
                                    attrBadge={{
                                      color: idx === 0
                                        ? 'primary'
                                        : idx === 1
                                          ? 'danger'
                                          : idx === 2
                                            ? 'success'
                                            : idx === 3
                                              ? 'warning'
                                              : 'info'
                                    }}
                                    className="me-1"
                                    style={{ fontSize: '0.75rem', padding: '0.25rem 0.45rem', lineHeight: 1.05 }}
                                  >
                                    {topic}
                                  </Badges>
                                );
                                return isMembershipTopic ? (
                                  <Link
                                    key={`topic-link-${item.id}-${idx}`}
                                    to={`/membership/membership-detail/${topicIdNum}`}
                                    title="Detail Membership"
                                    className="p-1 d-inline-block"
                                  >
                                    {badge}
                                  </Link>
                                ) : (
                                  <span key={`topic-link-${item.id}-${idx}`} className="p-1 d-inline-block">
                                    {badge}
                                  </span>
                                );
                              })}
                            </td>

                            <td style={{ verticalAlign: 'middle', wordBreak: "break-word", whiteSpace: "normal" }}>
                              {/* analytics label dikirim dari payload data[analytics_label] */}
                              {item?.data?.analytics_label ? (
                                <Badges
                                  attrBadge={{
                                    color: 'secondary'
                                  }}
                                  style={{ fontSize: '0.75rem', padding: '0.3rem 0.5rem', lineHeight: 1.05 }}
                                >
                                  {item.data.analytics_label}
                                </Badges>
                              ) : '-'}
                            </td>

                            <td style={{ verticalAlign: 'middle', fontWeight: 600, maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item.title}>
                              {item.title}
                            </td>

                            <td style={{ verticalAlign: 'middle', maxWidth: 220, overflow: 'hidden' }}>
                              <div style={{ maxHeight: 64, overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.body}</div>
                            </td>

                            <td style={{ verticalAlign: 'middle', wordBreak: "break-word", whiteSpace: "normal" }}>
                              {item?.data?.url ? (
                                <a href={item.data.url} target="_blank" rel="noopener noreferrer" style={{ wordBreak: "break-all" }}>
                                  {item.data.url}
                                </a>
                              ) : '-'}
                            </td>

                            <td style={{ verticalAlign: 'middle', width: 100 }}>
                              {item.image ? <img src={item.image} alt="notif-img" style={{ width: "100%", objectFit: 'cover', borderRadius: 4 }} /> : '-'}
                            </td>

                            <td style={{ verticalAlign: 'middle' }}>
                              {createdAt ? (
                                <div>
                                  <div style={{ fontWeight: 600 }}>{Moment(item.created_at).format("dddd, D MMMM YYYY HH:mm")}</div>
                                </div>
                              ) : '-'}
                            </td>

                            <td style={{ verticalAlign: 'middle' }}>
                              {scheduledAt ? (
                                <div>
                                  <div style={{ fontWeight: 600 }}>{item?.scheduled_at ? Moment(item.scheduled_at).format("dddd, D MMMM YYYY HH:mm") : '-'}</div>
                                </div>
                              ) : '-'}
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default HistoryNotif